import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why an internet diet and not cold turkey",
  "description": "",
  "published": "2011-08-19T00:00:00.000Z",
  "redirect_from": ["/blog/why-an-internet-diet-and-not-cold-turkey/swizec/2254"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Two days ago `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/my-ideas-are-shitty-so-im-going-on-an-internet-diet/swizec/2239",
        "title": "My ideas are shitty so I’m going on an internet diet"
      }}>{`I went on an internet diet`}</a>{` and a whole lot of `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-17-8/swizec/2244",
        "title": "I learned two things today 17.8."
      }}>{`people heard about it`}</a>{`. Flaking out is simply not an option.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.theage.com.au/ffxImage/urlpicture_id_1063625039656_2003/09/16/blaine,0.jpg",
        "alt": null,
        "title": "Man in box"
      }}></img></p>
    <p>{`I may have turned into one of those curiosities, like a guy who puts himself in a glass box in the middle of a square and claims he will live in there for a week ... people are intrigued by idiots doing idiotic stuff.`}</p>
    <p>{`While a few people applauded my effort, a lot of readers came out to tell me I'm Doing It Wrong (tm). That my list of rules is too permissive and won't let me achieve whatever I set out to achieve (I don't even know, I'm just seeing what happens, honest).`}</p>
    <p>{`Because the hour a day is too short to respond to everyone, let me try explaining the reasons behind every item on the list :)`}</p>
    <h2 {...{
      "id": "as-a-coding-reference-the-internet-is-ok"
    }}>{`as a coding reference, the internet is ok`}</h2>
    <p>{`Here's the thing, I'm a programmer, in an average day I work in four-ish different languages across at least three distinct pieces of technology. Some of which is changing so rapidly any offline resources I could find would be woefully out of date before even reaching the printer. Sometimes I need to pick up a new piece of technology quickly, it would be impossible to download docs in advance.`}</p>
    <p>{`I can't let experiments like these affect what I do for a living. No go.`}</p>
    <h2 {...{
      "id": "wikipedia-is-alright-but-keep-it-down"
    }}>{`wikipedia is alright, but keep it down`}</h2>
    <p>{`I am about to enter exam season. Wikipedia has proven to be the single best source for studying large swaths of computer science and mathematics. Normal reading material just isn't enough. I'm not talking about mindlessly browsing here, I'm just trying to avoid wastingtime whenever I want to make sure I understand something.`}</p>
    <h2 {...{
      "id": "i-will-continue-writing-my-blog"
    }}>{`I will continue writing my blog`}</h2>
    <p>{`A few months ago I set a goal to myself to reach 20k monthly readers of this blog by the end of the year. If I don't keep writing it this goal has no hope of being reached. I am doing my best to fit blogging into the hour of internet I have a day.`}</p>
    <p>{`I love writing and it's something I have to do regularly ... might as well publish it somewhere, see how people like it, get feedback, improve.`}</p>
    <h2 {...{
      "id": "using-750wordscom-every-morning-is-good"
    }}>{`using `}<a parentName="h2" {...{
        "href": "http://750words.com"
      }}>{`750words.com`}</a>{` every morning is good`}</h2>
    <p>{`This barely counts as internet. It's just somewhere I write what's on my mind every morning for nobody to ever read. But it keeps score and I don't want to break a 110 day streak.`}</p>
    <h2 {...{
      "id": "there-will-be-at-most-an-hour-every-evening-of-hnfbtwitteremail"
    }}>{`there will be at most an hour every evening of HN/fb/twitter/email`}</h2>
    <p>{`For a guy who is online 24/7 going to just an hour of internet is ... huge. I need to keep up with email because I have clients and stuff, twitter/fb are because I need a way of keeping in touch with people, especially because the exam season means I won't be able to meet them in person much. Similar to email, I have to respond to people talking to me on Twitter.`}</p>
    <p>{`And HN ... well I don't absolutely need need that, but I want to at least skim the titles on the frontpage to keep a grip on reality a bit.`}</p>
    <p>{`Oh and those complaining I'm on twitter outside the hour. I use `}<a parentName="p" {...{
        "href": "http://bufferapp.com"
      }}>{`Buffer`}</a>{` to schedule tweets ;)`}</p>
    <h2 {...{
      "id": "if-something-absolutely-spectacular-happens-you-are-allowed-to-tweet-no-reading-outside-the-hour"
    }}>{`if something absolutely spectacular happens you are allowed to tweet, no reading outside the hour!`}</h2>
    <p>{`Some news just shouldn't be kept to myself. What if I see aliens? Or `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-14-8/swizec/2207",
        "title": "I learned two things today 14.8."
      }}>{`meet a celebrity`}</a>{`? This is again part of that whole "keeping in touch" thing.`}</p>
    <h2 {...{
      "id": "checking-in-to-foursquare-is-questionable--perhaps-ban-it"
    }}>{`checking in to foursquare is questionable ... perhaps ban it?`}</h2>
    <p>{`Foursquare is arguably useless, but I want to check-in to places. If I go missing or something weird happens to me, at least people know where to start looking. And I like having a history of uninteresting places I have visited.`}</p>
    <h2 {...{
      "id": "skype-is-ok"
    }}>{`skype is ok`}</h2>
    <p>{`I don't use a phone.`}</p>
    <p>{`Skype is honestly my only means of communication with anyone. Especially now that I've banned twitter for most of the day ... twitter used to be the only reliable means of reaching me in a hurry.`}</p>
    <h2 {...{
      "id": "fin"
    }}>{`Fin`}</h2>
    <p>{`So there you have it. I hope that clears up some of the issues everyone had with my little experiment. And hey, if you think you can do better, you're welcome to try. We can compare notes :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      